var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 59.5,
    fill: "black",
    stroke: "#0065FC",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9493 29.7324C76.8717 24.0828 68.9964 21.1724 60.6932 21.686C45.5419 22.7132 33.3011 35.2965 32.7019 50.3621C32.6163 52.9301 33.3867 58.2374 33.9003 60.7198L34.4139 59.6926C35.3555 57.8094 36.5539 56.0974 38.0947 54.6421L53.8452 39.3197C54.0164 39.1485 54.102 39.0629 54.2732 38.8917C56.1564 37.1797 58.4676 35.9813 61.378 35.8101C65.7436 35.5533 69.938 37.0085 73.1053 40.0045C76.2725 43.0005 78.0701 47.1093 78.0701 51.4749C78.0701 52.5877 77.5565 53.7861 76.6149 54.7277L51.4484 79.3807C54.6156 82.3767 58.8959 84.0019 63.2615 83.7451C70.5375 83.317 75.418 76.2966 79.9536 71.761L86.8016 64.913C87.8288 63.8858 88.5992 62.6874 89.3696 61.489C91.2528 58.4929 92.2797 55.0701 92.2797 51.4749C92.2797 43.2573 88.8557 35.3821 82.9493 29.7324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8209 58.6667L89.3657 61.4915C88.5953 62.6899 87.6536 63.8884 86.6264 64.83L71.4752 79.9812C70.7904 80.5804 70.1056 81.094 69.6776 81.4364C67.88 82.7204 65.74 83.4908 63.3431 83.662C58.9775 83.9188 54.7831 82.4636 51.6159 79.4676C48.4487 76.4716 46.6511 72.3628 46.6511 67.9972C46.6511 66.8844 47.1647 65.686 48.1063 64.7444L73.3584 40.0915C70.1912 37.0954 65.9112 35.5518 61.5455 35.8086C58.6351 35.9798 56.1527 37.0951 54.2695 38.8071L53.8415 39.2351L38.1766 54.5579C36.6358 56.0131 35.4374 57.8107 34.4958 59.6083C33.2118 62.2619 32.4414 65.0868 32.4414 67.9116C32.4414 76.1292 35.8654 84.0044 41.8574 89.6541C47.9351 95.3037 55.8103 98.2141 64.1135 97.7005C79.1792 96.7589 91.4201 84.1756 92.0193 69.0244C92.1049 66.542 91.3345 61.0635 90.8209 58.6667Z",
    fill: "url(#paint0_linear_1969_15226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1969_15226",
    x1: 62.2317,
    y1: 35.7555,
    x2: 62.2317,
    y2: 97.7373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#203DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#095AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#0065FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.f4ab8c737bf6250defc1eda80aee2fe5.svg";
export { ForwardRef as ReactComponent };